export const mutations = {
  STORE_DAILTRANSACTIONS(state, dailytransactions) {
    state.dailytransactions = dailytransactions;
  },
  STORE_DAILTRANSACTION(state, dailytransaction) {
    state.dailytransaction = dailytransaction;
  },
  
};
export default mutations;



// WEBPACK FOOTER //
// ./src/vuex/modules/dailytransactions/mutations.js